/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：376
 */

"use strict"

export { i as b }
export { a }
export { s as c }
var r = {
  default: {
    viewBox: "0 0 1024 1024",
    path: ["M792.96 352a64 64 0 0 1 63.616 70.72l-50.56 480A64 64 0 0 1 742.4 960H281.6a64 64 0 0 1-63.616-57.28l-50.56-480A64 64 0 0 1 231.104 352h561.792zM384 464a48 48 0 0 0-47.552 41.472L336 512v288l0.448 6.528a48 48 0 0 0 95.104 0l0.448-6.528V512l-0.448-6.528A48 48 0 0 0 384 464z m256 0a48 48 0 0 0-47.552 41.472L592 512v288l0.448 6.528a48 48 0 0 0 95.104 0l0.448-6.528V512l-0.448-6.528A48 48 0 0 0 640 464zM512 64c81.6 0 148.928 48.896 158.72 112h257.28a48 48 0 0 1 6.528 95.552l-6.528 0.448h-832a48 48 0 0 1-6.528-95.552L96 176h257.28C363.008 112.896 430.336 64 512 64z"]
  }
}
var o = r
function i() {
  o = r
}
function a(e) {
  return o[e]
}
function s(e, t, n) {
  o[e] = {
    path: t,
    viewBox: n
  }
}
export default a
